"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _useRecipientsView = require('web/screens/Broadcast/Recipients/useRecipientsView'); var _useRecipientsView2 = _interopRequireDefault(_useRecipientsView);

const BLOCKED = { kind: 'blocked' }















/* M5, P3': the unsent recipients the launch gate would refuse (a missing
 * value without a fallback or default, or a render over the limit), one page
 * at a time from the recipients preview's blocked view; the server decides
 * who is blocked. Re-read as useRecipientsView re-reads: when the campaign's
 * recipients, variables or message change, and (throttled) as messages go
 * out. */
const useBlockedRecipients = (campaign) => {
  const [offset, setOffset] = _react.useState.call(void 0, 0)
  const { view, counts, error, reload } = _useRecipientsView2.default.call(void 0, campaign, BLOCKED, '', offset)
  const rows = _react.useMemo.call(void 0, () => _nullishCoalesce(_optionalChain([view, 'optionalAccess', _ => _.Rows]), () => ( [])), [view])
  const onPage = _react.useCallback.call(void 0, (page) => setOffset(page * _useRecipientsView.PAGE_SIZE), [])
  const total = _nullishCoalesce(_nullishCoalesce(_optionalChain([counts, 'optionalAccess', _2 => _2.blocked]), () => ( _optionalChain([view, 'optionalAccess', _3 => _3.Total]))), () => ( 0))
  // A page past the end (its recipients were removed) steps back to the last one with rows.
  _react.useEffect.call(void 0, 
    () => {
      if (view && offset > 0 && offset >= view.Total) setOffset(Math.max(0, Math.floor((view.Total - 1) / _useRecipientsView.PAGE_SIZE) * _useRecipientsView.PAGE_SIZE))
    },
    [view, offset],
  )
  return {
    isLoading: !view && !error,
    error,
    rows,
    total,
    page: Math.floor(offset / _useRecipientsView.PAGE_SIZE),
    pageCount: Math.ceil(total / _useRecipientsView.PAGE_SIZE),
    onPage,
    reload,
  }
}

exports. default = useBlockedRecipients
